import React, { Fragment } from "react";
import InputCard from "../../common/InputCard";

class CardsLayout extends React.Component {
  state = {};
  constructor() {
    super();
    this.table = [];
    this.cardsLayout = [
      // cards
      {
        title: "Card",
        hideTitle: true,
        items: [
          {
            label: {
              value: "PO Payment Terms",
              size: "calc(100% - 100px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vwhPoPmntTerms"
            },
            size: "20%",
            readOnly: true
          },
          {
            label: {
              value: "Container Flag",
              size: "calc(100% - 100px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vdiContainerLoad",
              maxLength: 5
            },
            size: "20%",
            readOnly: false
          },
          {
            label: {
              value: "Incoterms",
              size: "calc(100% - 100px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vwhIncoTerms"
            },
            size: "20%",
            readOnly: true
          },
          {
            label: {
              value: "Factory Build Days",
              size: "calc(100% - 100px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vwhFbuildDays"
            },
            size: "20%",
            readOnly: true
          },
          {
            label: {
              value: "Production Days",
              size: "calc(100% - 100px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vwhProdDays"
            },
            size: "20%",
            readOnly: true
          },
          {
            label: {
              value: "Stacking",
              size: "calc(100% - 100px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vdiStacking"
            },
            size: "20%",
            readOnly: true
          },
          {
            label: {
              value: "Port of Loading",
              size: "calc(100% - 100px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vdiLoadPort"
            },
            size: "20%",
            readOnly: true
          },
          {
            label: {
              value: "Factory Transit Days",
              size: "calc(100% - 100px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vwhFtransitDays"
            },
            size: "20%",
            readOnly: true
          },
          {
            label: {
              value: "Consolidation Days",
              size: "calc(100% - 100px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vwhConsolidDays"
            },
            size: "20%",
            readOnly: true
          },
          {
            label: {
              value: "Export Custom Days",
              size: "calc(100% - 100px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vwhEcustomDays"
            },
            size: "20%",
            readOnly: true
          },
          {
            label: {
              value: "Country Code",
              size: "calc(100% - 100px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "countryCode"
            },
            size: "20%",
            readOnly: true
          },
          {
            label: {
              value: "Transport Mode",
              size: "calc(100% - 100px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vdiTransportMode"
            },
            size: "20%",
            readOnly: true
          },
          {
            label: {
              value: "Source Agent",
              size: "calc(100% - 100px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vdiSourceAgent"
            },
            size: "20%",
            readOnly: true
          },
          {
            label: {
              value: "Ship Load Days",
              size: "calc(100% - 100px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vwhShipLoadDays"
            },
            size: "20%",
            readOnly: true
          },
          {
            label: {
              value: "Ocean Transit Days",
              size: "calc(100% - 100px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vwhOtransitDays"
            },
            size: "20%",
            readOnly: true
          },
          {
            label: {
              value: "EDI Destination Code",
              size: "calc(100% - 100px)",
              fontSize: "95%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vwhEdiDest"
            },
            size: "20%",
            readOnly: true
          },
          {
            label: {
              value: "EDI DI Vendor",
              size: "calc(100% - 100px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vwhEdiVendor"
            },
            size: "20%",
            readOnly: true
          },
          {
            label: {
              value: "Ship Unload Days",
              size: "calc(100% - 100px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vwhShipUnldDays"
            },
            size: "20%",
            readOnly: true
          },
          {
            label: {
              value: "Import Custom Days",
              size: "calc(100% - 100px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vwhIcustomDays"
            },
            size: "20%",
            readOnly: true
          },
          {
            label: {
              value: "Dom. Transit Days",
              size: "calc(100% - 100px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vwhDctransitDays"
            },
            size: "20%",
            readOnly: true
          },
          {
            label: {
              value: "Container Size",
              size: "calc(100% - 100px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vwhContainerSize",
              maxLength: 4
            },
            size: "20%",
            readOnly: false
          },
          {
            label: {
              value: "Standard Lead Time",
              size: "calc(100% - 100px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vwhStdLeadTime"
            },
            size: "20%",
            readOnly: true
          },
          {
            label: {
              value: "Variance Days",
              size: "calc(100% - 100px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vwhVarianceDays"
            },
            size: "20%",
            readOnly: true
          },
          {
            label: {
              value: "PSI Compliance Frequency",
              size: "50%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vwhPsiCompliance"
            },
            size: "40%",
            readOnly: true
          },
          {
            label: {
              value: "PSI Compliance Every",
              size: "calc(100% - 100px)",
              fontSize: "92%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vwhPsiDetailDays"
            },
            size: "20%",
            readOnly: true
          },
          {
            label: {
              value: "Days",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "unitShippedTag",
              noInput: true
            },
            size: "5%",
            readOnly: true
          },
          {
            label: {
              value: "PSI Last Compliance",
              size: "calc(43%)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vwhPsiLastDate"
            },
            size: "35%",
            readOnly: true
          }
        ]
      }
    ];
  }

  componentDidMount() {
    this.setState({ layout: this.cardsLayout });
  }

  formatData = props => {
    if (props) {
      this.cardsLayout.map((card, c) => {
        const inputName = Object.keys(props[c])[0];
        card.items.map((item, i) => {
          if (item.item.intemName === props[c][inputName][i].name) {
            item.item.value = props[c][inputName][i].value;
            item.item.obj = props[c][inputName][i].obj;
            item.item.checked = props[c][inputName][i].checked;
            item.item.span = props[c][inputName][i].span;
            item.label.value = props[c][inputName][i].label;
            item.item.injectedValue = props[c][inputName][i].injectedValue;
          }
          return null;
        });
        return null;
      });
    }
    return null;
  };
  getCardsInfo = (info, title) => {
    this.props.setCardsInfo({ [title]: info });
  };
  renderCards = () => {
    this.formatData(this.props.cardsData);

    return (
      <Fragment>
        <div style={{ flex: 1, display: "flex" }}>
          <div style={{ flex: 1 }} >
            <InputCard
              justifyContent="center"
              jsonObj={this.cardsLayout[0]}
              setCardsInfo={this.getCardsInfo}
              functions={{
                checkOrderConstraints: this.props.checkOrderConstraints
              }}
            />
          </div>
        </div>
      </Fragment>
    );
  };

  getTheJson = () => {
    for (let index = 0; index < this.cardsLayout.length; index++) {
      for (let i = 0; i < this.cardsLayout[index].items.length; i++) {
      }

    }
  };
  render() {
    return (
      <Fragment>
        {/* <button onClick={e => this.getTheJson()} /> */}
        <div className="cards-container" style={{ display: "flex" }}>
          {this.renderCards()}
        </div>
      </Fragment>
    );
  }
}
export default CardsLayout;
